module.exports = __webpack_public_path__ + "img/Vegetable.fb0b006e.jpg";